// import { GLOABLE } from "@/global";
import { centerApi, envState } from "../apiEntity";

export abstract class ActEntity {
    protected env: envState = { testing: process.env.NODE_ENV === "development" };
    protected get apis() { return centerApi };
    protected get base(): any { return centerApi };
    constructor() { };
}
